import { Link, Typography } from '@customink/pigment-react';

import {
  HIGH_COLOR_DESIGN_COLOR_COUNT,
  HIGH_COLOR_DESIGN_MIN_ORDER_QUANTITY,
} from '@/constants';
import { useEditDesignLink } from '@/hooks/Design';

type NoAlternativeProps = {
  designCid?: string;
};

export default function NoAlternative({ designCid }: NoAlternativeProps) {
  const handleEditDesign = useEditDesignLink(designCid);
  return (
    <>
      <Typography data-testid="min-qty-high-color-no-alt">
        Please either:
      </Typography>
      <ul style={{ margin: 0 }}>
        <li>
          <Typography>
            Increase the order quantity to{' '}
            {HIGH_COLOR_DESIGN_MIN_ORDER_QUANTITY} or more, or
          </Typography>
        </li>
        <li>
          <Typography>
            Reduce the number of colors in your design to fewer than{' '}
            {HIGH_COLOR_DESIGN_COLOR_COUNT} per side in the{' '}
            <Link onClick={handleEditDesign}>Design Lab</Link>.
          </Typography>
        </li>
      </ul>
    </>
  );
}
